import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { toast } from "react-toastify";
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import InputMask from "react-input-mask";

import { rootStore } from "../../Application";

import { tf, tf2,normalizeVolume, PrecisionCount, divideNumberByPieces, processRequestError } from "../../utils/utilities";
import { BalanceExchangeType, CoinType } from "../../utils/graphql";
import { API_HOST } from '../../utils/const';
import BigNumber from 'bignumber.js';

interface IFormBuyProps {
    currentCoin: CoinType;
    type: string;
}

const TypesOrder = {
    Limit: 'limit',
    Market: 'market'
}


const FormSell: FC<IFormBuyProps> = ({ currentCoin, type = "market" }) => {
    const { t } = useTranslation();

    const [currentRate, setCurrentRate] = useState<number>(1);
    const [inputBuy, setInputBuy] = useState<number | string>(null);
    const [inputTurnoverBuy, setInputTurnoverBuy] = useState<number | string>(null);

    let sumPrice = 0;

    // @ts-ignore
    useEffect(async () => {
        await rootStore.coinStore.getBalancesOne(currentCoin.coinSymbol);
    }, []);

    // @ts-ignore
    useEffect(async () => {
        await rootStore.coinStore.getBalancesBuyOne(currentCoin.baseSymbol);
    }, [rootStore.coinStore.balances]);

    // @ts-ignore
    useEffect(async () => {
        if (type === TypesOrder.Market) {
            if (rootStore.ordersStore.selectSell) {
                await setInputTurnoverBuy(Number(tf(rootStore.ordersStore.selectSell.turnovers, currentCoin.baseCoinScale)));
                await setCurrentRate(Number(tf(rootStore.ordersStore.selectSell.price, currentCoin.baseCoinScale)));
                await setInputBuy(Number(tf(rootStore.ordersStore.selectSell.amounts, currentCoin.baseCoinScale)));
            }
        }
        await rootStore.coinStore.getBalancesAll();
     }, [rootStore.ordersStore.selectSell]);

    // @ts-ignore
    useEffect(async () => {
        validateOutput('');
        validateInput('');
        if (type === TypesOrder.Market) {
            await setCurrentRate(Number(tf(currentCoin.rubRate, currentCoin.baseCoinScale)));
        }
    }, [type]);

    // @ts-ignore
    useEffect(async () => {
        await rootStore.coinStore.getBalancesOne(currentCoin.coinSymbol);
        await rootStore.coinStore.getBalancesAll();
        await setCurrentRate(Number(tf(currentCoin.rubRate, currentCoin.baseCoinScale)));
        await setInputBuy('');
        await setInputTurnoverBuy('');
    }, [currentCoin]);

    const handleKeyPress = (event) => {
        // Разрешаем: backspace, delete, tab и escape       
        let eventNative = event.nativeEvent
        console.log(eventNative.keyCode);
        if (eventNative.keyCode == 44 || eventNative.keyCode == 46 || eventNative.keyCode == 8 || eventNative.keyCode == 9 || eventNative.keyCode == 27 ||
            // Разрешаем: Ctrl+A
            (eventNative.keyCode == 65 && eventNative.ctrlKey === true) ||
            // Разрешаем: home, end, влево, вправо
            (eventNative.keyCode >= 35 && eventNative.keyCode <= 39)) {
                // console.log('Разрешенный: ', eventNative.keyCode);
            // Ничего не делаем
            return;
        } else {
            // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
            if ((eventNative.keyCode < 48 || eventNative.keyCode > 57) ) {
                event.preventDefault();
            }
        }
    }

    const setMax = () => {
        const setMax = {
            [TypesOrder.Limit]: () => validateInput(getMax()),
            [TypesOrder.Market]: () => validateInput(getMaxMarket())
        };
        setMax[type]();
    }

    const validateOutput = async (newValue) => {
        let min = 0;
        let max = currentRate * getMax();
        console.log(max);

        if (String(newValue).length === 0 || newValue == null) {
            await setInputTurnoverBuy('');
            await setInputBuy('');
            return;
        }

        newValue = String(newValue).replace(',', '.');

        if (newValue !== true && isNaN(newValue)) {
            newValue = min
        }

        if (Number(newValue) < Number(min)) {
            newValue = min
        }

        if (Number(newValue) > Number(max)) {
            newValue = max
            toast.error(`${t('exchange.message.info.max-amount')}`);
        }

        let sumPriceOrders = 0;

        if (type === TypesOrder.Market) {
            rootStore.ordersStore.getMaxCountOrdersBuy();

            let actualCurrend = rootStore.ordersStore.maxCountOrdersBuy;
            let tt = {
                amounts: new BigNumber(0),
                price: new BigNumber(0),
                turnovers: new BigNumber(0)
            };
            
            rootStore.ordersStore.buy.forEach(item => {
                if (actualCurrend > 0 && item.amountMyOrder !== item.amounts) {
                    tt.price = new BigNumber(item.price);
            
                    let amountDiff = new BigNumber(item.amounts).minus(new BigNumber(Number(item.amountMyOrder)));
                    // console.log(amountDiff.abs().toString());
            
                    if (amountDiff.isLessThan(0)) {
                        return;
                    }
            
                    let actualCurrendBN = new BigNumber(actualCurrend);
                    if (amountDiff.isGreaterThanOrEqualTo(actualCurrendBN)) {
                        tt.turnovers = tt.turnovers.plus(tt.price.times(actualCurrendBN));
                    } else {
                        tt.turnovers = tt.turnovers.plus(tt.price.times(amountDiff));
                    }
            
                    // console.log(tt.turnovers.toString());
            
                    actualCurrend = actualCurrendBN.minus(amountDiff).toNumber();
                }
            });
            
            sumPriceOrders = tt.turnovers.toNumber();

            if (Number(newValue) > sumPriceOrders) {
                newValue = sumPriceOrders;
                toast.error(`${t('exchange.message.info.max-amount-order')}`);
            }
        }

        if (!/^\d+([.,]?\d*)?$/.test(newValue) || newValue < 0) {
            newValue = '0';
        }

        let currend = normalizeVolume(+newValue, getStepOutput())
        let rate = currentRate;
        if (type=="market")  rate = getPriceForOutputMarket(currend) 

        // normalizeVolume returns numner. if user enters 1. then it's converted into 1
        // thus dot disappears and user can't enter 1.2
        if(newValue === (currend.toString() + '.')){
            currend = newValue;
        }


        if ((newValue.toString().includes('.') && newValue.toString().endsWith('0')) || newValue.toString().endsWith('.') || newValue === '0') {
            if (PrecisionCount(newValue) > currentCoin.baseCoinScale) {
                newValue = currend;
            }
            setInputTurnoverBuy(newValue);
            if (type === TypesOrder.Market) {
                console.log('sumPriceOrders', sumPriceOrders, newValue);
                let actualTurnovers = newValue;
                let amounts = 0;
                rootStore.ordersStore.buy.forEach(item => {
                    if (actualTurnovers > 0 && Number(item.amountMyOrder) < item.amounts) {
                        console.log(item, (item.amounts - Number(item.amountMyOrder)) * item.price, ((item.amounts - Number(item.amountMyOrder)) * item.price) / actualTurnovers);
                        amounts += ((item.amounts - Number(item.amountMyOrder)) * item.price) / actualTurnovers;
                        
                        actualTurnovers -= (item.amounts - Number(item.amountMyOrder)) * item.price;
                    }
                });
                return;
            }
            const rateBN = new BigNumber(rate);
            const currendBN = new BigNumber(newValue);

            const result = new BigNumber(1).div(rateBN).times(currendBN).toFixed(currentCoin.baseCoinScale);
            console.log('result1', result);

            setInputBuy(tf(Number(result), currentCoin.baseCoinScale));
            // // setInputBuy(Number(tf2(1 / rate * newValue, 8)));
        } else {
            setInputTurnoverBuy(currend);
            if (type === TypesOrder.Market) {
                // console.log('sumPriceOrders', sumPriceOrders, currend);
                let actualTurnovers = new BigNumber(currend);
                let amounts = new BigNumber(0);
                
                rootStore.ordersStore.buy.forEach(item => {
                    let amountMyOrder = new BigNumber(Number(item.amountMyOrder));
                    let itemAmounts = new BigNumber(item.amounts);
                    let itemPrice = new BigNumber(item.price);
                
                    if (actualTurnovers.gt(0) && amountMyOrder.lt(itemAmounts)) {
                        let remainingAmount = itemAmounts.minus(amountMyOrder); // Остаток, который можно купить
                        let cost = remainingAmount.times(itemPrice); // Стоимость остатка
                
                        if (cost.lte(actualTurnovers)) {
                            amounts = amounts.plus(remainingAmount);
                            actualTurnovers = actualTurnovers.minus(cost);
                        } else {
                            let purchasableAmount = actualTurnovers.dividedBy(itemPrice);
                            amounts = amounts.plus(purchasableAmount);
                            actualTurnovers = new BigNumber(0);
                        }
                    }
                });
                
                setInputBuy(amounts.toFixed(currentCoin.baseCoinScale));
                return;
            }
            const rateBN = new BigNumber(rate);
            const currendBN = new BigNumber(currend);

            const result = new BigNumber(1).div(rateBN).times(currendBN).toFixed(currentCoin.baseCoinScale);

            setInputBuy(Number(result));
            // setInputBuy(Number(tf2(1 / rate * currend, 8)));
        }
    }

    const validateInput = async (newValue) => {
        let min = 0;
        let max = getMax();
        if (String(newValue).length==0 || newValue==null) {
            await setInputTurnoverBuy('');
            await setInputBuy('');
            return
        }

        newValue = String(newValue).replace(',', '.');

        if (newValue !== true && isNaN(newValue) && !newValue.includes(',')) {
            newValue = min;
        }

        if (Number(newValue) < Number(min)) {
            newValue = min;
        }

        if (Number(newValue) > Number(max)) {
            newValue = max;
            toast.error(`${t('exchange.message.info.max-amount')}`);
        }

        if (type === TypesOrder.Market) {    
            if (Number(newValue) > getMaxMarket()) {
                newValue = getMaxMarket();
                toast.error(`${t('exchange.message.info.max-amount-order')}`);
            }
        }


        if (!/^\d+([.,]?\d*)?$/.test(newValue) || newValue < 0) {
            newValue = '0';
        }
       
        let currend = normalizeVolume(+newValue, getStep())
        let rate = currentRate;
        // console.log('currend', currend)
        if (type=="market")  rate = getPriceForInputMarket(currend);

        // normalizeVolume returns numner. if user enters 1. then it's converted into 1
        // thus dot disappears and user can't enter 1.2
        if(newValue === (currend.toString() + '.')){
            currend = newValue;
        }

        if (((newValue.toString().includes('.') || newValue.toString().includes('.')) && newValue.toString().endsWith('0')) || newValue.toString().endsWith('.') || newValue === '0') {
            if (PrecisionCount(newValue) > currentCoin.coinScale) {
                newValue = currend
            }
            console.log("!--",rate,currend, newValue, sumPrice, currentCoin.baseCoinScale,(tf(rate * newValue, currentCoin.baseCoinScale)));
            setInputBuy(newValue);
            let actualCurrend = currend;
            if (type === 'market') {
                let tt = {
                    amounts: new BigNumber(0),
                    price: new BigNumber(0),
                    turnovers: new BigNumber(0)
                };
                
                rootStore.ordersStore.buy.forEach(item => {
                    if (actualCurrend > 0 && item.amountMyOrder !== item.amounts) {
                        tt.price = new BigNumber(item.price);
                
                        let amountDiff = new BigNumber(item.amounts).minus(new BigNumber(item.amountMyOrder));
                        console.log(amountDiff.abs().toString());
                
                        if (amountDiff.isLessThan(0)) {
                            return;
                        }
                
                        let actualCurrendBN = new BigNumber(actualCurrend);
                        if (amountDiff.isGreaterThanOrEqualTo(actualCurrendBN)) {
                            tt.turnovers = tt.turnovers.plus(tt.price.times(actualCurrendBN));
                        } else {
                            tt.turnovers = tt.turnovers.plus(tt.price.times(amountDiff));
                        }
                
                        console.log(tt.turnovers.toString());
                
                        actualCurrend = actualCurrendBN.minus(amountDiff).toNumber();
                    }
                });
                
                tt.turnovers = new BigNumber(tt.turnovers.toFixed(currentCoin.baseCoinScale));
                sumPrice = Number(tt.turnovers);
                
                setInputTurnoverBuy(new BigNumber(tf(sumPrice, currentCoin.baseCoinScale)).toNumber());
                return;
            }
            setInputTurnoverBuy(Number(tf(sumPrice, currentCoin.baseCoinScale)));
        } else {
            setInputBuy(currend);
            console.log("!-",rate,currend, sumPrice, currentCoin.baseCoinScale,(tf(rate * currend, currentCoin.baseCoinScale)));
            let actualCurrend = currend;
            if (type === 'market') {
                let tt = {
                    amounts: new BigNumber(0),
                    price: new BigNumber(0),
                    turnovers: new BigNumber(0)
                };
                
                rootStore.ordersStore.buy.forEach(item => {
                    if (actualCurrend > 0 && item.amountMyOrder !== item.amounts) {
                        tt.price = new BigNumber(item.price);
                
                        let amountDiff = new BigNumber(item.amounts).minus(new BigNumber(item.amountMyOrder));
                        console.log(amountDiff.abs().toString());
                
                        if (amountDiff.isLessThan(0)) {
                            return;
                        }
                
                        let actualCurrendBN = new BigNumber(actualCurrend);
                        if (amountDiff.isGreaterThanOrEqualTo(actualCurrendBN)) {
                            tt.turnovers = tt.turnovers.plus(tt.price.times(actualCurrendBN));
                        } else {
                            tt.turnovers = tt.turnovers.plus(tt.price.times(amountDiff));
                        }
                
                        console.log(tt.turnovers.toString());
                
                        actualCurrend = actualCurrendBN.minus(amountDiff).toNumber();
                    }
                });
                
                tt.turnovers = new BigNumber(tt.turnovers.toFixed(currentCoin.baseCoinScale));
                sumPrice = Number(tt.turnovers);
                
                setInputTurnoverBuy(new BigNumber(tf(sumPrice, currentCoin.baseCoinScale)).toNumber());
                return;
            }
            setInputTurnoverBuy(Number(tf(rate * currend, currentCoin.baseCoinScale)));
        }
    }

    const getPriceForInputMarket = (value: number) => {
        let amount = 0;
        let turnover = 0;
        let price = null;
      
        rootStore.ordersStore.buy.forEach(item=>{
            if (amount <= value) {
                amount += Number(item.amounts);
                amount -= Number(item.amountMyOrder);

                if (Number(item.amountMyOrder) > Number(item.amounts)) {
                    amount = 0;
                }

                price = Number(item.price);
                turnover += Number(item.turnovers);

                if (Number(item.amountMyOrder) > 0) {
                    let priceBN = new BigNumber(item.price);
                    let amountBN = new BigNumber(item.amountMyOrder ? item.amountMyOrder : 0);
                    let result = priceBN.times(amountBN).decimalPlaces(2).toNumber();

                    turnover -= result;

                    if (Number(item.amountMyOrder) > Number(item.amounts)) {
                        turnover = 0;
                    }
                }
            };
        });

        turnover = Number((turnover).toFixed(currentCoin.baseCoinScale));
        amount = Number((amount).toFixed(currentCoin.baseCoinScale));
        if (amount) {
            let turnovers = new BigNumber(turnover);
            price = (turnovers.dividedBy(amount).decimalPlaces(currentCoin.baseCoinScale, BigNumber.ROUND_HALF_UP)).toNumber();
        }
        // console.log('getPriceForInputMarket', price, sumPrice, value, sumPrice/value);
 
        if (Number(price) > 0) {
            setCurrentRates(price);
            return price;
        } else {
            return currentRate;
        };
    }

    const getPriceForOutputMarket = (value: number) => {
        let amount = 0;
        let turnover = 0;
        let price = null;
        rootStore.ordersStore.buy.forEach(item=>{
            if (amount <= value) {
                amount += Number(item.amounts);
                amount -= Number(item.amountMyOrder);

                if (Number(item.amountMyOrder) > Number(item.amounts)) {
                    amount = 0;
                }

                price = Number(item.price);
                turnover += Number(item.turnovers);

                if (Number(item.amountMyOrder) > 0) {
                    let priceBN = new BigNumber(item.price);
                    let amountBN = new BigNumber(item.amountMyOrder ? item.amountMyOrder : 0);
                    let result = priceBN.times(amountBN).decimalPlaces(currentCoin.baseCoinScale).toNumber();

                    turnover -= result;

                    if (Number(item.amountMyOrder) > Number(item.amounts)) {
                        turnover = 0;
                    }
                }
            };
        });

        turnover = Number((turnover).toFixed(currentCoin.baseCoinScale));
        amount = Number((amount).toFixed(currentCoin.baseCoinScale));
        if (amount) {
            let turnovers = new BigNumber(turnover);
            price = (turnovers.dividedBy(amount).decimalPlaces(currentCoin.baseCoinScale, BigNumber.ROUND_HALF_UP)).toNumber();
        }

        if (Number(price)>0) {
            setCurrentRates(price);
            return price;
        } else {
            return currentRate;
        }
    }

    const setCurrentRates = (newValue: string | number) => {
        newValue = String(newValue).replace(',', '.');

        if (!/^\d+([.,]?\d*)?$/.test(newValue) || Number(newValue) < 0) {
            newValue = '0';
        };

        let currend = normalizeVolume(+newValue, getStepOutput());

        // normalizeVolume returns number. if user enters 1. then it's converted into 1
        // thus dot disappears and user can't enter 1.2
        if(newValue === (currend.toString() + '.')){
            currend = Number(newValue);
        }

        if ((newValue.includes('.') && newValue.endsWith('0')) || newValue.endsWith('.') || newValue === '0') {
            if (PrecisionCount(newValue) > currentCoin.baseCoinScale) {
                newValue = currend;
            }
            setCurrentRate(Number(newValue));
            setInputTurnoverBuy(Number(tf(Number(inputBuy) * Number(newValue), currentCoin.baseCoinScale))); // умножение
           
        } else {
            setCurrentRate(currend);
            setInputTurnoverBuy(Number(tf(Number(inputBuy) * currend, currentCoin.baseCoinScale))); // Умножение
        }
    }

    const getStep = () => {
        if (currentCoin) {
            return 1 / Math.pow(10, currentCoin.coinScale); // деление
        } else {
            return 0.1
        }
    }

    const getStepOutput = () => {
        if (currentCoin) {
            return 1 / Math.pow(10, currentCoin.baseCoinScale); // деление
        } else {
            return 0.1
        }
    }

    const getMaxMarket = () => {
        let max = new BigNumber(0);
        let sumPriceOrders = new BigNumber(0);
    
        rootStore.ordersStore.buy.forEach(one => {
            console.log(one.amounts - Number(one.amountMyOrder));
            if (one.amounts - Number(one.amountMyOrder) < 0) {
                return;
            }
            max = max.plus(new BigNumber(one.amounts).minus(new BigNumber(Number(one.amountMyOrder))));
            sumPriceOrders = sumPriceOrders.plus(new BigNumber(one.turnovers));
            console.log('sumPriceOrders before', sumPriceOrders.toNumber());
    
            if (new BigNumber(Number(one.amountMyOrder)).gt(0)) {
                sumPriceOrders = sumPriceOrders.minus(new BigNumber(one.price).times(new BigNumber(Number(one.amountMyOrder))));
            }
            console.log('sumPriceOrders after', sumPriceOrders.toNumber());
        });
    
        sumPrice = Number(sumPriceOrders.toFixed(currentCoin.baseCoinScale)); // Сохраняем с точностью 12 знаков
    
        if (max.lt(new BigNumber(rootStore.coinStore.balanceSell.balance))) {
            return max.toFixed(currentCoin.baseCoinScale); // Возвращаем как строку с 12 знаками точности
        } else {
            return getMax(); // Рекурсивный вызов, если max больше баланса
        }
    };

    const getMax = () => {
        return rootStore.coinStore.balanceSell ? rootStore.coinStore.balanceSell.balance : 1;
    }

    const onCreateOrder = async () => {
        const ERROR_RATE_CURRENCY_PERCENT = 0.15;
        try {
            if (type === TypesOrder.Limit) {
                if (Number(inputBuy) <= 0 || currentRate <= 0 || Number(inputTurnoverBuy) <= 0|| inputBuy > getMax()) {
                    toast.error(`${t('exchange.message.error.count-order')}`);
                    throw new Error(`${t('exchange.message.error.count-order')}`);
                }

                let currentRateAlways = Number(tf(currentCoin.rubRate, currentCoin.baseCoinScale));
                let minRate = currentRateAlways - (currentRateAlways * ERROR_RATE_CURRENCY_PERCENT);
                let maxRate = currentRateAlways + (currentRateAlways * ERROR_RATE_CURRENCY_PERCENT);
                if (currentRate > maxRate || currentRate < minRate) {
                    toast.error(`${t('exchange.message.error.course-ranges')}`);
                }

                // Сделать вывод сообщения в зависимости от ответа бэка
                await rootStore.ordersStore.createOrder(currentCoin.symbol, "SELL", type, Number(inputBuy), currentRate, Number(inputTurnoverBuy));
                toast.success(`${t('exchange.message.success.created-order')}`);
            } else if (type === TypesOrder.Market) {
                if (Number(inputBuy) <= 0 || inputBuy > getMax()) {
                    toast.error(`${t('exchange.message.error.volume-order')}`);
                    throw new Error(`${t('exchange.message.error.volume-order')}`);
                }

                await rootStore.ordersStore.createOrder(currentCoin.symbol, "SELL", type, Number(inputBuy), 0, Number(inputTurnoverBuy));
                setInputTurnoverBuy('');
                setInputBuy('');

                // Сделать вывод сообщения в зависимости от ответа бэка
                toast.success(`${t('exchange.message.success.sell-order')}`);
            }

            await rootStore.coinStore.getBalancesOne(currentCoin.coinSymbol);
            await rootStore.ordersStore.getOrdersCurrent(currentCoin.symbol, 10, 1); // Посмотретть что за числа 10 и 1
            await rootStore.ordersStore.getOrdersHistory(currentCoin.symbol, 10, 1); // Посмотретть что за числа 10 и 1
            await rootStore.coinStore.getBalancesAll();
        } catch (e) {
            processRequestError(e);
        }
    }
    return (
        <div className="main-block">
            <div className="balance-head">
                <h2 className="operation-title">{t('exchange.sell')} {currentCoin?.coinSymbol} </h2>
                {rootStore.coinStore.balanceSell &&
                    <span className="balance">
                        {divideNumberByPieces(tf(rootStore.coinStore.balanceSell?.balance, currentCoin.coinScale))} {currentCoin?.coinSymbol}
                    </span>
                }
                {rootStore.coinStore.balanceSell &&
                    <span className="balance cold">
                        {divideNumberByPieces(tf(rootStore.coinStore.balanceSell?.freezeBalance, currentCoin.coinScale))} {currentCoin?.coinSymbol}
                    </span>
                }
            </div>
            <div className="bye-sell">
                <form className="main-form" action="#">
                    <div className="main-form__wrap">
                        <div className="main-form__field">
                            <label className="main-form__label" htmlFor="#">{t('exchange.amount')}</label>
                            <div className="main-form__input-wrap">
                                <InputMask className="main-form__input"
                                    type='text'
                                    value={inputBuy}
                                    step={getStep()}
                                    placeholder={currentCoin?.coinSymbol}
                                    onKeyPress={handleKeyPress}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => validateInput(e.target.value)}
                                />
                                <div className="main-form__max" onClick={() => setMax()}>
                                    MAX
                                </div>
                            </div>
                        </div>
                        <div className="main-form__field">
                            <label className="main-form__label" htmlFor="#">{t('exchange.quotation')}</label>
                            <div className="main-form__input-wrap">
                                <InputMask className="main-form__input"
                                    type="text"
                                    disabled={type == "market"}
                                    value={currentRate}
                                    formatChars={
                                        {'9': '[0-9]'}
                                    }
                                    onKeyPress={handleKeyPress}
                                    step={getStepOutput()}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCurrentRates(e.target.value)}
                                />
                                <span className="main-form__subinfo">{currentCoin?.baseSymbol}</span>
                            </div>
                        </div>
                        <div className="main-form__field">
                            <label className="main-form__label" htmlFor="#">{t('exchange.total')}</label>
                            <div className="main-form__input-wrap">
                                <input
                                    className="main-form__input"
                                    type="text"
                                    value={inputTurnoverBuy}
                                    placeholder={currentCoin?.baseSymbol}
                                    step={getStepOutput()}
                                    onKeyPress={handleKeyPress}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => validateOutput(e.target.value)}
                                />
                                <div className="main-form__max" onClick={() => setMax()}>
                                    MAX
                                </div>
                            </div>
                        </div>
                        <button
                            className="btn tertiary"
                            onClick={async () => await onCreateOrder()}
                            type="button"
                        >
                            {t('exchange.sell')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default observer(FormSell)
